export const bookWithMeUpdateButtonLabel = "E_$zxd";
export const bookWithMeDiscardButtonLabel = "jtuYpd";
export const bookWithMeDeleteButtonLabel = "ILLund";
export const bookWithMeDeleteConfirmationText = "a_7Xec";
export const bookWithMeDeleteButtonTooltip = "xC5pAb";
export const bookWithMeDiscardChangesConfirmation = "z8$SNc";
export const bookWithMeUpdateAndShareButtonLabel = "OZ8jce";
export default {bookWithMeUpdateButtonLabel,bookWithMeDiscardButtonLabel,bookWithMeDeleteButtonLabel,bookWithMeDeleteConfirmationText,bookWithMeDeleteButtonTooltip,bookWithMeDiscardChangesConfirmation,bookWithMeUpdateAndShareButtonLabel};